import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SettingType, SettingsService } from 'src/app/core/settings/settings.service';

@Component({
  selector: 'setting-selector',
  templateUrl: './setting-selector.component.html',
  styleUrls: ['./setting-selector.component.scss']
})
export class SettingSelectorComponent implements OnInit {
  @Output() 
  settingSelected = new EventEmitter<SettingType>();

  constructor(private settingsService: SettingsService) { }
  
  availableSettings: SettingType[];

  ngOnInit(): void {
    this.availableSettings = this.settingsService.getAllSettingTypes();
  }

  onSelection(selectedItem: SettingType) {
    this.settingSelected.emit(selectedItem);
  }
}
